import { useEffect, useRef, useState } from 'react'
import { getLocale } from '../../helpers'
import './SingleInput.scss';

const localization = getLocale()

export const SingleInput = ({
  buttonText,
  placeholder,
  onSubmit,
  onSuccessText,
  loadingText = localization.writingThatDown,
}) => {
  const inputRef = useRef(null)
  const [isSending, setIsSending] = useState(false)
  const [didError, setDidError] = useState(false)
  const [showSuccessText, setShowSuccessText] = useState(false)

  const submitValue = () => {
    if (!inputRef || !inputRef.current || isSending || inputRef.current.value === '') {
      return
    }
    setIsSending(true)
    setDidError(false)

    onSubmit(inputRef.current.value).then((didSuccess) => {
      setIsSending(false)

      if (didSuccess) {
        if (inputRef.current?.value) inputRef.current.value = ''
        setShowSuccessText(true)
      } else {
        setDidError(true)
      }
    })
  }

  useEffect(() => {
    if (!showSuccessText) {
      return
    }

    let isMounted = false

    setTimeout(() => {
      if (!isMounted) {
        setShowSuccessText(false)
      }
    }, 4000)

    return () => {
      isMounted = true
    }
  }, [showSuccessText])

  return (
    <div className='single-input'>
      <div className={`single-input-container ${didError ? 'error' : ''}`}>
        <input
          ref={inputRef}
          placeholder={placeholder}
          onKeyUp={(e) => {
            setDidError(false)
            if (e.key === 'Enter') {
              submitValue()
            }
          }}
        />
        <div className='button' onClick={submitValue}>{buttonText}</div>
      </div>
      {onSuccessText && showSuccessText && <div className='status-text'>{onSuccessText}</div>}
      {isSending && <div className='status-text'>{loadingText}</div>}
    </div>
  )
}